












































import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import {
  groupCompareSynthEZAvgScore,
  getClassList
} from '@/api/teachingProtection/assessment'
import Rank from './_components/Rank.vue'
import List from './_components/List.vue'

@Component({
  components: {
    Rank,
    List
  }
})
export default class extends Vue {
  // private frirstChartData: any = {}
  private tabData = [
    { code: 101, description: '排名' },
    { code: 102, description: '详细数据' }
  ];
  private tabActive = 101;
  private list: Array<object> = [];

  // private mainArr = []
  // private subArr = []
  private classroomName: any = '';
  private sexName: any = '';
  private compareName: any = '';
  created() {
    if (!this.$route.query.searchParams) return
    let params = JSON.parse(this.$route.query.searchParams as string)
    localStorage.setItem('searchParams', JSON.stringify(params))

    const classroomNames: any = []
    const sexNames: any = []
    const compareNames: any = []

    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res: any) => {
      res.data.array.map((v: any) => {
        v.classrooms.map((q: any) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v: any) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')

    this.$enums.classroomTypes.map((v: any) => {
      if (params.compareIds.indexOf(v.code) !== -1) {
        compareNames.push(v.description)
      }
    })
    this.compareName = compareNames.join('、')
    groupCompareSynthEZAvgScore(params).then((res) => {
      // this.frirstChartData = res.data.synthEZAvgScore
      this.list = res.data.barChart || []

      // this.mainArr = this.barDataArray.slice(0, 5)
      // this.subArr = this.barDataArray.slice(5, 8)
    })
  }
}
